import React, { SFC } from 'react'
import { Button, Card, Col, Form } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

interface Props {
  emailSent: boolean;
  forgotEmailError: boolean;
  forgotPassword: string;
  showLoginError: boolean;
  onChangeField: (e: any, name: string) => void;
  onSubmitEmail: (e: any) => void;
}

const ForgotPassword: SFC<Props> = (props) => {
  const {emailSent, forgotEmailError, forgotPassword, showLoginError, onChangeField, onSubmitEmail} = props

  let loginError = (<div></div>)
	
  if(showLoginError)
    loginError = (
      <div className="loading-error-msg-2">
        <FontAwesomeIcon icon={['fas', 'exclamation-circle']} className="login-error-icon" size="3x"/>
        <div>
          <span className="loading-error-msg-span">Sorry, your email is not registered.</span>
          <span>Please check it and try again.</span>
        </div>
      </div>
    )

  let forgotPwdMsg = 'Enter the email address associated with your account, and we’ll email you a link to reset your password.'
  if(emailSent)
    forgotPwdMsg = 'A link to reset your password has been sent.'

  let errorMessage = (<div></div>)
  if(forgotEmailError)
    errorMessage = (
      <Form.Text className="login-error-msg">
        <FontAwesomeIcon icon={['fas', 'exclamation-circle']} className="login-error-icon"/>This field requires a valid email address.
      </Form.Text>
    )
  
  return (
	
    <Card className="login-card">
      <Card.Body className="login-card-body">
        <span className="login-forgot-title">Forgot Password.</span>
        <span className='login-forgot-text'>{forgotPwdMsg}</span>
        {loginError}
        {emailSent===false?(
          <Form className='login-form'>
            <Form.Group as={Col} lg={12} md={12} sm={12} xs={12}>
              <Form.Label>Email</Form.Label>
              <Form.Control size="lg" className="login-ipt" isInvalid={forgotEmailError} onChange={(e: any)=>{onChangeField(e, 'forgotPassword')}}/>
              {errorMessage}
            </Form.Group>
          </Form>
        ):(
          <div></div>
        )}
        <div className="login-forgot-pwd-container">
          <Link to="/login" className="login-forgot-pwd">Back to Login</Link>
        </div>
        {emailSent===false?(
          <Button id="login-btn" disabled={forgotPassword===''||forgotEmailError} onClick={onSubmitEmail}>
					Send
          </Button>
        ):(
          <div></div>
        )}
      </Card.Body>
    </Card>
  )
}
export default ForgotPassword